module.exports = __webpack_public_path__ + "../resources/img/storebadge_fr.7bf5d76e.png";